// ##### Travel-specific utility functions
// Generic date utilities (calculateDuration, calculateDaysUntil, formatDate) live in shared_items/formatConventions

const placeArrivalKey = (place) =>
  String(place?.arrival_date ?? place?.date_range?.start ?? '').trim();

/**
 * Order places by arrival date (ISO strings compare lexicographically).
 * Places without a date sort last; tie-breaker: id when present.
 * @param {boolean} descending - true = newer first (default)
 */
export const sortPlacesByArrival = (places, descending = true) => {
  if (!places || !Array.isArray(places) || places.length === 0) return [];
  return [...places].sort((a, b) => {
    const da = placeArrivalKey(a);
    const db = placeArrivalKey(b);
    if (da && db) {
      const cmp = descending ? db.localeCompare(da) : da.localeCompare(db);
      if (cmp !== 0) return cmp;
    } else if (da && !db) return -1;
    else if (!da && db) return 1;
    const ida = a.id != null ? Number(a.id) : 0;
    const idb = b.id != null ? Number(b.id) : 0;
    return descending ? idb - ida : ida - idb;
  });
};

/** Newest arrival first — alias for sortPlacesByArrival(places, true). */
export const sortPlacesByArrivalDesc = (places) => sortPlacesByArrival(places, true);

// ##### Validate trip data structure — domain-specific, knows about trip shape
export const validateTripData = (trip) => {
  return trip &&
         trip.places &&
         Array.isArray(trip.places) &&
         trip.places.length > 0 &&
         trip.start_date &&
         trip.end_date;
};

// ##### Get current year
export const getCurrentYear = () => new Date().getFullYear();

// ##### Check if date is in current year
export const isDateInCurrentYear = (dateStr) => {
  if (!dateStr) return false;
  try {
    return new Date(dateStr).getFullYear() === getCurrentYear();
  } catch {
    return false;
  }
};
